/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useId, useState } from 'react' 
import { Icon, Intent } from '@blueprintjs/core'
import { __ } from "src/libs/utilities"
import IScalarForm from '../interface/IScalarForm'
import Scalar from './Scalar'

const Boolean = (props: IScalarForm) : JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<BooleanEnabled {...props} />}
        desabledForm={<BooleanDisabled {...props} />}
    />
} 
export default Boolean 

export const BooleanEnabled = ( props: IScalarForm ): JSX.Element => {
    const [value, setValue] = useState<boolean>( typeof props.value !== "undefined" ? props.value : !!props.default)
    useEffect(() => {
        setValue(typeof props.value !== "undefined" ? props.value : !!props.default)
    }, [ props.value ])
    const id = useId()
    const onChange = (evt: any) => {
        const { checked } = evt.currentTarget         
        if( props.onChange )
        {
            props.onChange( checked,  props.field, "" )
        }   
    }

    return <div className=" d-flex my-4">
        <input 
            id = {id} 
            type = "checkbox" 
            data-testid="scalar-boolean"
            className = "_checkbox m-0"
            checked = { value } 
            onChange={onChange}
        />
        <label htmlFor={id} className="ml-3 mr-0 my-0 user-select-none">
            { __(value 
                ? 
                props.enabledLabel ? props.enabledLabel : "Yes" 
                : 
                props.disabledLabel ? props.disabledLabel : "No"
            )}
        </label>  
    </div>
} 
 
const BooleanDisabled = ( props: IScalarForm ): JSX.Element => {
    const [value,] = useState<boolean>( typeof props.value !== "undefined" ? props.value : !!props.default)
    return value
        ?
        <Icon size={22} icon="tick" intent={Intent.SUCCESS} className='my-auto' /> 
        :
        <Icon size={22} icon="cross" intent={Intent.DANGER} className='my-auto' /> 
} 
 